import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-assessment',
  templateUrl: './assessment.component.html',
  styleUrls: ['./assessment.component.scss']
})
export class AssessmentComponent implements OnInit {
  assessmentList:string;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService) { }

  ngOnInit() {

    let assessData = {
      token:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVc2VySUQiOjE1NywiaWF0IjoxNjEwNzg4MDYxfQ.nEYD4ja0X_M8GJIBpw535g4OGVyoHaCJGngjV23fOzc",
      userID:157,
      hostID: 54
    }

    this.apiService.assignmentList(assessData).subscribe((res:any)=>{
      console.log(res);
      this.assessmentList = res.data.assessmentData.data;
      
    } , async err => {

    })

  }

  userProfile(){
    this.router.navigateByUrl(`userprofile`);
  }
  
  enrollment(){   
    this.router.navigateByUrl(`enrollment`);
  }

  segmentChanged(completed){
    console.log(completed);

  }
  assessment(){
    this.router.navigateByUrl(`assessment`);
  }
  dashboard(){    
    this.router.navigateByUrl(`dashboard`);
  }
  assignment(){
    this.router.navigateByUrl(`assignment`);
  }
  notice(){
    this.router.navigateByUrl(`notice`); 
  }
  enquiry(){
    this.router.navigateByUrl(`enquiry`);
  }
  content(){
    this.router.navigateByUrl(`content`);
  }
  classes(){
    this.router.navigateByUrl(`courses`);
  }
  calender(){
    this.router.navigateByUrl(`calender`);
  }
  requirement(){
    
  }
}
